import { Axios } from "../../../axios";

export function setGuest({ commit }) {
	commit("setGuest");
}

export function setApplicantType({ commit }, applicantType) {
	commit("setApplicantType", applicantType);
}

export function setStudentType({ commit }, studentType) {
	commit("setStudentType", studentType);
}

export function setInstitutions({ commit }, institutions) {
	commit("setInstitutions", institutions);
}

export function set_user_from_server({ commit }) {
	Axios.get("/user")
		.then(function(response) {
			if (response.data.data.loggedIn) {
				commit("setUserType", "authed");
				commit("setEmail", response.data.data.userEmail);
			} else if (response.data.data.guest) {
				commit("setUserType", "guest");
				commit("setEmail", null);
			}
		})
		.catch(function() {
			commit("setUserType", "unknown");
			commit("setEmail", null);
		});
}

export function create_guest_account({ dispatch, commit }) {
	Axios.post("/user/guest")
		.then(function() {
			commit("setUserType", "guest");
			commit("setEmail", null);
			commit("clear_alerts");
		})
		.catch(function() {
			dispatch("add_alert", {
				variant: "danger",
				msg: "Unable to continue as guest at this time"
			});
		});
}

export function login_to_server({ dispatch, commit }, payload) {
	Axios.post("/user", {
		emailAddress: payload.email,
		password: payload.password
	})
		.then(function(res) {
			if (res.data.success) {
				commit("setEmail", payload.email);
				commit("setUserType", "authed");
				commit("clear_alerts");
			} else {
				commit("clear_alerts");
				dispatch("add_alert", {
					variant: "danger",
					msg: "Invalid login: " + res.data.message
				});
			}
		})
		.catch(function(error) {
			commit("clear_alerts");
			if (
				error &&
				error.response &&
				error.response.status &&
				(error.response.status === 400 || error.response.status === 401)
			) {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Invalid login: " + error.response.data.message
				});
			} else {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Invalid login: " + "Server error. Please try again later"
				});
			}
		});
}

export function create_account({ dispatch, commit }, payload) {
	Axios.put("/user", {
		emailAddress: payload.email,
		password: payload.password,
		passwordConfirm: payload.passwordConfirm
	})
		.then(function(res) {
			if (res.data.success) {
				commit("setEmail", res.data.data.email);
				commit("setUserType", "authed");
				commit("clear_alerts");
			} else {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Cannot create account: " + res.data.message
				});
			}
		})
		.catch(function(error) {
			if (
				error &&
				error.response &&
				error.response.status &&
				error.response.status >= 400 &&
				error.response.status < 500
			) {
				dispatch("add_alert", {
					variant: "danger",
					msg: error.response.data.message
				});
			} else {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Internal server error. Please try again later"
				});
			}
		});
}

export function logout_user({ commit }) {
	Axios.get("/user/logout");

	commit("setUserType", "unknown");
	commit("setEmail", null);
}

export function forgot_password({ dispatch }, email) {
	Axios.post("/user/forgot_pass", {
		email: email
	})
		.then(function() {
			dispatch("add_alert", {
				variant: "info",
				msg:
					"An email was sent to the address provided that contains a link to reset your password."
			});
		})
		.catch(function() {
			dispatch("add_alert", {
				variant: "danger",
				msg: "Internal server error. Please try again later"
			});
		});
}

export function check_reset_token({ dispatch, commit }, payload) {
	Axios.get("/user/forgot_pass", {
		params: {
			email: payload.email,
			token: payload.token
		}
	}).catch(function() {
		commit("setUserType", "new");
		dispatch("add_alert", {
			variant: "danger",
			msg: "Unable to validate the token you have provided."
		});
	});
}

export function reset_password({ dispatch, commit }, payload) {
	Axios.post("/user/reset_pass", {
		email: payload.email,
		password: payload.password,
		passwordConfirm: payload.passwordConfirm,
		token: payload.token
	})
		.then(function() {
			commit("setEmail", payload.email);
			commit("setUserType", "authed");
			commit("clear_alerts");
		})
		.catch(function() {
			dispatch("add_alert", {
				variant: "danger",
				msg: "Internal server error. Please try again later"
			});
		});
}
